export const TIMES_OUTBOUND_HEADER_TEXT = "Times - Outbound";
export const TIMES_RETURN_HEADER_TEXT = "Times - Return";

export const DEPARTURE_TEXT = "Departure";
export const ARRIVAL_TEXT = "Arrival";

export const TIME = "Time";
